import cn from 'classnames';
import React, {FC} from 'react';

import './dd-parameters-rule.less';
import {DdParametersRuleItem} from './dd-parameters-rule-item/dd-parameters-rule-item';
import {EDdParameterRuleItemSourceType, EDdParameterRuleItemType} from './dd-parameters-rule-item/dd-parameters-rule-item-types';

interface IDdParametersRuleProps {
    isInEditMode?: boolean;
    layout?: 'vertical' | 'horizontal';
    childSourceType?: EDdParameterRuleItemSourceType;
    parentSourceType?: EDdParameterRuleItemSourceType;
}

export const DdParametersRule: FC<IDdParametersRuleProps> = (
    {
        isInEditMode, layout = 'horizontal', childSourceType, parentSourceType,
    }: IDdParametersRuleProps,
) => (
    <div className={cn('dd-parameters-rule')}>
        <DdParametersRuleItem
            type={EDdParameterRuleItemType.parent}
            isInEditMode={isInEditMode}
            layout={layout}
            sourceType={parentSourceType}
        />
        <div className={cn('report-dd-parameters-arrow')} />
        <DdParametersRuleItem
            type={EDdParameterRuleItemType.child}
            isInEditMode={isInEditMode}
            layout={layout}
            sourceType={childSourceType}
        />
    </div>
);
